<form [formGroup]="skjema" novalidate (submit)="importerAksjeeierbok()">
  <mat-toolbar color="primary">
    <span>{{ "Importer aksjeeierbok" | translate }}</span>
    <button mat-icon-button (click)="avbryt()" type="button" class="example-icon" aria-label="Lukk dialog">
      <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <div class="organisasjonsnummer">

      <mat-form-field>
        <mat-label>{{ "Organisasjonsnummer" | translate }}</mat-label>
        <input matInput [formControl]="skjema.controls.organisasjonsnummer" [errorStateMatcher]="matcher"
               data-testid="organisasjonsnummer">
        <!--          <mat-hint>{{"Kun norske organisasjonsnummer"|translate}}</mat-hint>-->
        <mat-hint align="end">{{ orgnrUtenSpace().length }}/9</mat-hint>

        @if (orgnrUtenSpace().length === 9 && skjema.controls.organisasjonsnummer.hasError('norskOrganisasjonsnummer')) {
          <mat-error>{{ "Ikke gyldig norsk orgnisasjonsnummer"|translate }}</mat-error>
        }

        @if (orgnrUtenSpace().length > 9) {
          <mat-error>{{ "Organisasjonsnummer er 9 siffer"|translate }}</mat-error>
        }

      </mat-form-field>
    </div>

    @if (erIkkeNil(sammendrag())) {
      @switch (sammendrag()?.status) {
        @case (SkatteetatenStatus.OK) {
          <inline-melding [voksHorisontalt]="true" type="info">
            <div>
              <tittel-verdi stil="horisontal" tittel="{{ 'Navn' | translate }}"
                            verdi="{{sammendrag()?.orgnavn | standard}}"/>
              <tittel-verdi stil="horisontal" tittel="{{'Organisasjonsnummer' | translate}}"
                            verdi="{{sammendrag()?.orgnummer | standard}}"/>
              <tittel-verdi stil="horisontal" tittel="{{'Antall aksjeeiere' | translate}}"
                            verdi="{{sammendrag()?.antallAksjeeiere | standard}}"/>
              <tittel-verdi stil="horisontal" tittel="{{'Antall aksjer' | translate}}"
                            verdi="{{sammendrag()?.antallAksjerTotalt | standard}}"/>
            </div>
          </inline-melding>
        }
        @case (SkatteetatenStatus.IKKE_FUNNET) {
          <inline-melding [voksHorisontalt]="true" type="advarsel">
            {{
              'Fant ikke {orgnr} hos skatteetaten. Tall fra skatteetaten er fra {dato}.'|translate:{
                orgnr: orgnrUtenSpace(),
                dato: skatteetatenDato()|plaindate
              }
            }}
          </inline-melding>
        }
        @case (SkatteetatenStatus.FOR_MANGE) {
          <inline-melding [voksHorisontalt]="true" type="feil">
            <div>
              <div>{{ 'Kan ikke importerer aksjeeierbok.'|translate }}</div>
              <div>{{ 'Styreplan støtter ikke import av aksjeeierbok med mer enn 50 aksjonærer.' }}</div>
              <div>{{ 'Kontakt Styreplan så finner vi en løsning.' }}</div>
            </div>
            <div>
              <tittel-verdi stil="horisontal" tittel="{{ 'Navn' | translate }}"
                            verdi="{{sammendrag()?.orgnavn | standard}}"/>
              <tittel-verdi stil="horisontal" tittel="{{'Organisasjonsnummer' | translate}}"
                            verdi="{{sammendrag()?.orgnummer | standard}}"/>
              <tittel-verdi stil="horisontal" tittel="{{'Antall aksjeeiere' | translate}}"
                            verdi="{{sammendrag()?.antallAksjeeiere | standard}}"/>
              <tittel-verdi stil="horisontal" tittel="{{'Antall aksjer' | translate}}"
                            verdi="{{sammendrag()?.antallAksjerTotalt | standard}}"/>
            </div>
          </inline-melding>
        }
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt" | translate }}</button>
    <button mat-raised-button color="primary" type="submit" cdkFocusInitial [disabled]="!kanImportere()|| lagrer()"
            [visSpinner]="lagrer()">{{ "Importer aksjeeierbok" | translate }}
    </button>
  </mat-dialog-actions>

</form>
